<script lang="ts">
  import { authed, confirm, plugins, projectMetas, readonly, t } from '@dabble/app';
  import { UserProject } from '@dabble/data/types';
  import Icon from '@dabble/toolkit/Icon.svelte';
  import {
    mdiArchive,
    mdiContentDuplicate,
    mdiDelete,
    mdiPen,
    mdiPencil,
    mdiShare,
    mdiTextBoxMultiple,
    mdiUndoVariant,
  } from '@mdi/js';
  import { createEventDispatcher } from 'svelte';

  export let userProject: UserProject;
  const { uid } = plugins.stores;

  let dispatch = createEventDispatcher();
  $: projectMeta = $projectMetas[userProject.projectId];
  $: isTemplate = projectMeta.isTemplate;
  $: canEditTemplate = $authed && projectMeta.roles[$uid] && isTemplate;
  $: hasAccess = !!projectMeta.roles[$uid];

  async function makeTemplate() {
    if (await confirm($t('project_create'), $t('template_confirm'), { yesNo: true })) {
      dispatch('template');
    }
  }
</script>

{#if hasAccess}
  <button class="dropdown-item" on:click={() => dispatch('rename')} disabled={$readonly}>
    <Icon path={mdiPencil} />
    {$t(isTemplate ? 'template_rename' : 'project_rename')}
  </button>
{/if}
{#if !isTemplate}
  <button class="dropdown-item" on:click={() => dispatch('duplicate')} disabled={$readonly}>
    <Icon path={mdiContentDuplicate} />
    {$t('project_duplicate')}
  </button>
  <button class="dropdown-item" on:click={makeTemplate} disabled={$readonly}>
    <Icon path={mdiTextBoxMultiple} />
    {$t('project_create')}
  </button>
{/if}
{#if isTemplate}
  {#if !canEditTemplate}
    <button class="dropdown-item" on:click={() => dispatch('view')} disabled={$readonly}>
      <Icon path={mdiTextBoxMultiple} />
      {$t('template_view')}
    </button>
  {:else}
    <button class="dropdown-item" on:click={() => dispatch('edit')} disabled={$readonly}>
      <Icon path={mdiPen} />
      {$t('template_edit')}
    </button>
  {/if}
  <button class="dropdown-item" on:click={() => dispatch('share')} disabled={$readonly}>
    <Icon path={mdiShare} />
    {$t('template_share')}
  </button>
{/if}
{#if userProject.category === 'archive'}
  <button class="dropdown-item" on:click={() => dispatch('category', '')} disabled={$readonly}>
    <Icon path={mdiArchive} />
    {$t('project_unarchive')}
  </button>
{:else}
  <button class="dropdown-item" on:click={() => dispatch('category', 'archive')} disabled={$readonly}>
    <Icon path={mdiArchive} />
    {$t('project_archive')}
  </button>
{/if}
{#if userProject.trashed}
  <button class="dropdown-item" on:click={() => dispatch('restore')} disabled={$readonly}>
    <Icon path={mdiUndoVariant} />
    {$t('restore_from_trash')}
  </button>
  <hr />
{/if}
<button class="dropdown-item" on:click={() => dispatch('delete')} disabled={$readonly}>
  <Icon path={mdiDelete} />
  {userProject.trashed ? $t('delete_permanently') : $t('send_to_trash')}
</button>
